/**
 * @fileoverview ゲーム定数定義 - 型安全性を重視した設計
 */

// 型定義

/** @typedef {'red'|'blue'|'green'|'yellow'|'purple'} PieceColor */
/** @typedef {'title'|'ready'|'processing'|'paused'|'gameover'} GameStatusType */

// ゲーム盤面定数

/** @type {number} ゲーム盤面のサイズ（9x9固定） */
const BOARD_SIZE = 9;

/** @type {number} ゲーム盤面の行数 */
const ROWS = BOARD_SIZE;

/** @type {number} ゲーム盤面の列数 */
const COLS = BOARD_SIZE;

/** @type {number} ピースのサイズ（ピクセル） */
const PIECE_SIZE = 70;

/** @type {number} 落下開始前の演出ディレイ（ミリ秒） */
const FALL_START_DELAY_MS = 100;

// ピース色定数

/** @type {Readonly<Record<string, PieceColor>>} ピース色の定数オブジェクト */
const PIECE_COLORS = Object.freeze({
  RED: /** @type {PieceColor} */ ('red'),
  BLUE: /** @type {PieceColor} */ ('blue'),
  GREEN: /** @type {PieceColor} */ ('green'),
  YELLOW: /** @type {PieceColor} */ ('yellow'),
  PURPLE: /** @type {PieceColor} */ ('purple'),
});

/** @type {readonly PieceColor[]} ピース色の配列（順序保証） */
const PIECE_COLOR_LIST = Object.freeze(Object.values(PIECE_COLORS));

/** @deprecated 後方互換性のため残存。PIECE_COLOR_LISTを使用してください */
const colors = PIECE_COLOR_LIST;

// ゲーム状態定数

/** @type {Readonly<Record<string, GameStatusType>>} ゲーム状態の定数 */
const GameStatus = Object.freeze({
  Title: /** @type {GameStatusType} */ ('title'),
  Ready: /** @type {GameStatusType} */ ('ready'),
  Processing: /** @type {GameStatusType} */ ('processing'),
  Paused: /** @type {GameStatusType} */ ('paused'),
  GameOver: /** @type {GameStatusType} */ ('gameover'),
});

// CSS同期のためwindowに公開
if (typeof window !== 'undefined') {
  window.__GAME_CONSTANTS__ = { BOARD_SIZE, ROWS, COLS, PIECE_SIZE };
}

// エクスポート

export {
  // 型定義（JSDocで参照可能）
  // PieceColor, GameStatusType

  // ゲーム盤面定数
  BOARD_SIZE,
  ROWS,
  COLS,
  PIECE_SIZE,
  FALL_START_DELAY_MS,

  // ピース色定数
  PIECE_COLORS,
  PIECE_COLOR_LIST,
  colors, // 後方互換性のため残存

  // ゲーム状態定数
  GameStatus,
};
